import React, { useEffect } from 'react';
import RelativeContainer from '../containers/RelativeContainer';
import SaveIcon from './SaveIcon';
import { StyledTextInput } from './styles';

export default function TextInput({
    value,
    onChange,
    placeholder,
    style,
    onClose,
    containerStyle,
    changes,
    onSave,
    loading,
    error,
    readOnly,
    noBorder,
}) {
    useEffect(() => {
        const handleEnterDown = ({ key }) => {
            if (key === 'Enter') {
                onSave();
            }
        };

        if (onSave) {
            window.addEventListener('keydown', handleEnterDown);
        }

        return () => window.removeEventListener('keydown', handleEnterDown);
    }, [onSave]);

    return (
        <RelativeContainer
            style={{
                height: 30,
                ...containerStyle,
            }}
        >
            <StyledTextInput
                readOnly={readOnly}
                autoComplete={'new-password'}
                placeholder={readOnly ? '' : placeholder}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                style={{
                    height: '100%',
                    fontSize: '16px',
                    color: '#777',
                    pointerEvents: readOnly ? 'none' : 'auto',
                    border: 'none',
                    ...style,
                }}
            />
            {onSave ? (
                <SaveIcon
                    onClose={onClose}
                    loading={loading}
                    error={error}
                    changes={changes}
                    onSave={onSave}
                />
            ) : null}
        </RelativeContainer>
    );
}
